// Validação de CPF
export const validateCPF = (cpf: string): boolean => {
  // Remove caracteres não numéricos
  const cleanCPF = cpf.replace(/\D/g, '');
  
  // Verifica se tem 11 dígitos
  if (cleanCPF.length !== 11) return false;
  
  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cleanCPF)) return false;
  
  // Validação do primeiro dígito verificador
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleanCPF.charAt(i)) * (10 - i);
  }
  let remainder = 11 - (sum % 11);
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cleanCPF.charAt(9))) return false;
  
  // Validação do segundo dígito verificador
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleanCPF.charAt(i)) * (11 - i);
  }
  remainder = 11 - (sum % 11);
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cleanCPF.charAt(10))) return false;
  
  return true;
};

// Formatação de CPF
export const formatCPF = (cpf: string): string => {
    // Remove tudo que não for número
    let cleanCPF = cpf.replace(/\D/g, '');
  
    // Limita a 11 dígitos
    cleanCPF = cleanCPF.slice(0, 11);
  
    // Formata somente se tiver pelo menos 3 números
    if (cleanCPF.length <= 3) return cleanCPF;
    if (cleanCPF.length <= 6) return cleanCPF.replace(/(\d{3})(\d{1,3})/, '$1.$2');
    if (cleanCPF.length <= 9) return cleanCPF.replace(/(\d{3})(\d{3})(\d{1,3})/, '$1.$2.$3');
    return cleanCPF.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, '$1.$2.$3-$4');
  };
  

// Validação de telefone
export const validatePhone = (phone: string): boolean => {
  const cleanPhone = phone.replace(/\D/g, '');
  // Aceita telefones com 10 ou 11 dígitos (com DDD)
  return cleanPhone.length === 10 || cleanPhone.length === 11;
};

// Formatação de telefone
export const formatPhone = (phone: string): string => {
    let cleanPhone = phone.replace(/\D/g, ''); // só números
    cleanPhone = cleanPhone.slice(0, 11);
  
    if (cleanPhone.length <= 10) {
      return cleanPhone.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3').replace(/-$/, '');
    } else {
      return cleanPhone.replace(/^(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3').replace(/-$/, '');
    }
  };
  

// Validação de email
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Sanitização de texto
export const sanitizeText = (text: string): string => {
  return text
    .trim()
    // .replace(/\s+/g, ' ') // Remove espaços múltiplos
    .replace(/[<>]/g, ''); // Remove caracteres potencialmente perigosos
};

// Validação de data
export const validateDate = (date: string): boolean => {
  const dateObj = new Date(date);
  return dateObj instanceof Date && !isNaN(dateObj.getTime());
};

// Validação de data futura
export const validateFutureDate = (date: string): boolean => {
  const dateObj = new Date(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return dateObj >= today;
};

// Validação de período (data fim > data início)
export const validateDateRange = (startDate: string, endDate: string): boolean => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  return end > start;
};

// Validação de valor monetário
export const validateMoney = (value: string | number): boolean => {
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  return !isNaN(numValue) && numValue >= 0;
};

// Formatação de valor monetário
export const formatMoney = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};

// Validação de quantidade
export const validateQuantity = (quantity: string | number): boolean => {
  const numQuantity = typeof quantity === 'string' ? parseInt(quantity) : quantity;
  return !isNaN(numQuantity) && numQuantity >= 0 && Number.isInteger(numQuantity);
};

// Validação de CEP
export const validateCEP = (cep: string): boolean => {
  const cleanCEP = cep.replace(/\D/g, '');
  return cleanCEP.length === 8;
};

// Formatação de CEP
export const formatCEP = (cep: string): string => {
  let cleanCEP = cep.replace(/\D/g, '');
  cleanCEP = cleanCEP.slice(0, 8);
  
  if (cleanCEP.length <= 5) return cleanCEP;
  return cleanCEP.replace(/(\d{5})(\d{1,3})/, '$1-$2');
};